/**
 * Мост web ↔ общий пакет дизайн-токенов.
 *
 * Пакет @russian-love/design-tokens — единый источник правды для web и
 * mobile-app. Здесь из его значений инжектятся CSS-переменные бренда в
 * :root при старте приложения. Значения совпадают с определёнными в
 * styles/theme.css — инжект идемпотентен и ничего не переопределяет,
 * только гарантирует, что бренд-переменные живут в одном источнике.
 */
import { colors } from "@design-tokens";

export function injectDesignTokenCssVariables(): void {
  const root = document.documentElement;
  const vars: Record<string, string> = {
    "--brand-from": colors.brandFrom,
    "--brand-to": colors.brandTo,
    "--brand-cta-shadow": colors.brandCtaShadow,
    "--brand-surface-warm": colors.brandSurfaceWarm,
  };
  for (const [name, value] of Object.entries(vars)) {
    root.style.setProperty(name, value);
  }
}
